var pt_BR = {
  "Add Quantity Breaks to your product page": "Adicione descontos por quantidade à sua página de produto",
  "Add Upsell.com to your ": "Adicione Upsell.com à sua ",
  "Add to cart click": "Clique em Adicionar ao carrinho",
  "All time": "Todo o período",
  "and select": "e selecione",
  "button": "botão",
  "Cart drawer page": "Página da Gaveta do carrinho",
  "Cart page": "Página do Carrinho",
  "Check status": "Verificar status",
  "Checkout page": "Página de Checkout",
  "Checkout click": "Clique em Finalizar compra",
  "Click": "Clique em",
  "Click on": "Clique em",
  "Click the": "Clique no",
  "Custom slot": "Slot personalizado",
  "Custom slots": "Slots personalizados",
  "Custom Slots": "Slots personalizados",
  "Enable in theme editor": "Ativar no editor de temas",
  "contact support.": "entre em contato com o suporte.",
  "from the right sidebar": "da barra lateral direita",
  "Go to App Embeds": "Ir para incorporações de app",
  "Go to your Cart drawer page": "Vá para sua página da Gaveta do carrinho",
  "Go to your Cart page": "Vá para sua página do Carrinho",
  "Go to your Checkout page": "Vá para sua página de Checkout",
  "Go to your Order status page": "Vá para sua página de Status do pedido",
  "Go to your Post purchase page": "Vá para sua página Pós-compra",
  "Go to your Product page": "Vá para sua página do Produto",
  "Go to your Thank you page": "Vá para sua página de Agradecimento",
  "items": "itens",
  "in the left sidebar": "na barra lateral esquerda",
  "Last 12 months": "Últimos 12 meses",
  "Last 30 days": "Últimos 30 dias",
  "Last 365 days": "Últimos 365 dias",
  "Last 7 days": "Últimos 7 dias",
  "Last 90 days": "Últimos 90 dias",
  "Last month": "Mês passado",
  "Last year": "Ano passado",
  "Make sure": "Certifique-se de que",
  "Need assistance? Contact our support team for help.": "Precisa de ajuda? Entre em contato com nossa equipe de suporte.",
  "Order status page": "Página de Status do pedido",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Nosso aplicativo está passando por um pouco de mágica para melhorar sua experiência.",
  "Post purchase page": "Página Pós-compra",
  "Product page": "Página do Produto",
  "Save": "Salvar",
  "Scroll to the bottom and select": "Role até o final e selecione",
  "Select": "Selecionar",
  "Success. Please continue.": "Sucesso. Por favor, continue.",
  "Thank you page": "Página de Agradecimento",
  "The Upsell.com team.": "A equipe Upsell.com.",
  "The Upsell.com widget is not placed on ": "O widget Upsell.com não está posicionado em ",
  ". Please follow the steps above or ": ". Por favor, siga os passos acima ou ",
  "Today": "Hoje",
  "toggle is on": "a opção está ativada",
  "Total": "Total",
  "under": "em",
  "We apologize for any inconvenience caused,": "Pedimos desculpas por qualquer inconveniente causado,",
  "We apologize for any inconvenience caused.": "Pedimos desculpas por qualquer inconveniente causado.",
  "We'll be done in a few minutes!": "Terminaremos em alguns minutos!",
  "We're improving our services!": "Estamos melhorando nossos serviços!",
  "Widget already added": "Widget já adicionado",
  "Yesterday": "Ontem",
  "You enabled the widget in your online store but didn't save it in the Upsell editor": "Você ativou o widget na sua loja online, mas não salvou no editor Upsell",
  "You placed the widget on the ": "Você posicionou o widget em ",
  ", but you didn't save it in Shopify editor. Please go back to ": ", mas não o salvou no editor do Shopify. Por favor, volte para ",
  " and save the changes.": " e salve as alterações."
};

export { pt_BR as default };
//# sourceMappingURL=pt_BR.json.js.map
